import React, {useEffect, useState, useContext} from 'react';
import {withRouter} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {Loader} from 'components';
import {PageContainer} from 'layouts';
import {ProductsContext, ValuesContext} from 'contexts';
import ProductFormGenerator from './ProductFormGenerator';
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  backButtonContainer: {
    paddingTop: '72px',
    paddingLeft: '276px',
    position: 'absolute'
  },
  title: {
    textAlign: 'center',
  },
  loader: {
    display: 'block',
    margin: '50px auto',
  },
}));

const ProductForm = (props) => {
  const classes = useStyles();
  const {bu, category, productName, productSku} = props.match.params;

  const {actions} = useContext(ProductsContext);
  const {
    state: valuesState,
    actions: valuesActions
  } = useContext(ValuesContext);

  const [loading, setLoading] = useState(true);
  const [editValues, setEditValues] = useState(null);

  useEffect(() => {
    if (!valuesState.values.length) {
      valuesActions.fetchAllValues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.location.state) {
      setEditValues(props.location.state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.state]);

  useEffect(() => {
    if (productName) {
      (async () => {
        const product = await actions.getProductByName(
          bu,
          category,
          productName
        );
        setEditValues(product);
        setLoading(false);
      })();
    } else if (productSku) {
      (async () => {
        const product = await actions.getProductBySku(
          bu,
          category,
          productSku
        );
        setEditValues(product);
        setLoading(false);
      })();
    } else {
      setLoading(false);
    }
  }, [setEditValues, setLoading, actions.getProductByName, actions, bu, category, productName]);

  const getSpecifierValues = (specifier) => valuesActions.getValues(bu, category, specifier);

  return (
    <>
      <div className={classes.backButtonContainer}>
        <Tooltip title="Back" arrow>
          <IconButton onClick={() => props.history?.goBack()}>
            <ArrowBackIcon/>
          </IconButton>
        </Tooltip>
      </div>
      <PageContainer component="main" maxWidth="md">
        {loading ? (
          <Loader size={75} className={classes.loader}/>
        ) : productName && !editValues ? (
          'product not found'
        ) : (
          <ProductFormGenerator
            getSpecifierValues={getSpecifierValues}
            editValues={editValues}
          />
        )}
      </PageContainer>
    </>
  );
};

export default withRouter(ProductForm);
